module.exports = __webpack_public_path__ + "img/ayudantes-mobile.f084d1c8.webp";